import { render, staticRenderFns } from "./myVouchersPage.vue?vue&type=template&id=516c0f37&scoped=true&"
import script from "./myVouchersPage.vue?vue&type=script&lang=ts&"
export * from "./myVouchersPage.vue?vue&type=script&lang=ts&"
import style0 from "./myVouchersPage.vue?vue&type=style&index=0&id=516c0f37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c0f37",
  null
  
)

export default component.exports